'use client';

import { controlSizeClassName } from '@statura/ui';
import { CircleHelp } from 'lucide-react';
import { normalizeHelpChatPath } from '@/lib/help/help-path';

type PageHelpOpenerProps = {
  path?: string;
  className?: string;
};

export function dispatchOpenHelpChat(path?: string | null): void {
  const fromArg = normalizeHelpChatPath(path);
  const fromWindow =
    typeof window !== 'undefined' ? normalizeHelpChatPath(window.location.pathname) : null;
  window.dispatchEvent(
    new CustomEvent('open-help-chat', {
      detail: { path: fromArg ?? fromWindow },
    }),
  );
}

export function PageHelpOpener({ path, className }: PageHelpOpenerProps) {
  return (
    <button
      type="button"
      onClick={() => dispatchOpenHelpChat(path)}
      aria-label="Ask for help on this screen"
      title="Ask for help on this screen"
      data-page-help-opener="true"
      className={
        className ??
        `${controlSizeClassName('toolbar')} inline-flex w-9 items-center justify-center rounded-control border border-control-border/30 !p-0 text-text-muted hover:bg-surface-soft focus:outline-none focus-visible:ring-2 focus-visible:ring-focus`
      }
    >
      <CircleHelp className="h-5 w-5" aria-hidden="true" />
    </button>
  );
}
